import { useEffect, useRef } from 'react';
import './PoisonFangAnimation.css';

export default function PoisonFangAnimation({ onComplete, playerRef, opponentRef }) {
  const elementsRef = useRef([]);

  useEffect(() => {
    const playerEl = playerRef.current;
    const opponentEl = opponentRef.current;
    if (!playerEl || !opponentEl) return;

    const container = playerEl.parentElement;
    const oRect = opponentEl.getBoundingClientRect();
    const cRect = container.getBoundingClientRect();

    const centerX = oRect.left - cRect.left + oRect.width / 2;
    const centerY = oRect.top - cRect.top + oRect.height / 2;

    const elements = [];

    // 1. Create the main fang animation
    const fangAnim = document.createElement('div');
    fangAnim.className = 'poison-fang-anim';
    fangAnim.style.setProperty('--sx', `${centerX - 96}px`);
    fangAnim.style.setProperty('--sy', `${centerY - 96}px`);
    container.appendChild(fangAnim);
    elements.push(fangAnim);

    const impactTime = 400; // ms, to match the bite frame

    // 2. On impact, create poison effects
    const impactTimer = setTimeout(() => {
      opponentEl.classList.add('poison-fang-hit');

      // Create dripping poison particles
      for (let i = 0; i < 10; i++) {
        const drip = document.createElement('div');
        drip.className = 'poison-fang-drip';
        drip.style.left = `${centerX + (Math.random() - 0.5) * 60}px`;
        drip.style.top = `${centerY}px`;
        drip.style.animationDelay = `${Math.random() * 0.3}s`;
        container.appendChild(drip);
        elements.push(drip);
      }

      // Create rising poison bubbles
      for (let i = 0; i < 15; i++) {
        const bubble = document.createElement('div');
        bubble.className = 'poison-fang-bubble';
        bubble.style.left = `${centerX}px`;
        bubble.style.top = `${centerY}px`;
        const angle = -60 - Math.random() * 60;
        const distance = 40 + Math.random() * 40;
        bubble.style.setProperty('--dx', `${Math.cos(angle * Math.PI / 180) * distance}px`);
        bubble.style.setProperty('--dy', `${Math.sin(angle * Math.PI / 180) * distance}px`);
        bubble.style.animationDelay = `${0.1 + Math.random() * 0.4}s`;
        container.appendChild(bubble);
        elements.push(bubble);
      }
    }, impactTime);

    // Cleanup
    const cleanupTime = impactTime + 1500;
    const cleanupTimer = setTimeout(() => {
      elements.forEach(el => el.remove());
      opponentEl.classList.remove('poison-fang-hit');
      onComplete();
    }, cleanupTime);

    elementsRef.current = elements;

    return () => {
      clearTimeout(impactTimer);
      clearTimeout(cleanupTimer);
      elementsRef.current.forEach(el => el.remove());
      if (opponentEl) opponentEl.classList.remove('poison-fang-hit');
    };
  }, [onComplete, playerRef, opponentRef]);

  return null;
}

PoisonFangAnimation.moveType = 'poison';
